<!--实时电能质量,三相电压和不平衡度 virtualDeviceRTCurve-->
<template>
  <div class="myvirtualDeviceRTCurve">
    <div class="con" style="background-color: #eee;">
      <div class="tree-left" style="height:calc(100vh - 152px);">
        <elUnitTree @checkFun='checkFun' :dataList='virtualDeviceList'></elUnitTree>
      </div>
      <div class="right-table">
        <div class="search-input-btn" style="width:100%;height: auto;">
          <span style="width: 60px;">应用类型</span>

          <elUnitTree2></elUnitTree2>

          <el-button @click="mysearch" type="primary" plain class="search-btn">查询</el-button>
        </div>
        <div class="myradio-group">
          <div :class="['item', 'item1', { 'item-active': tabPosition == 'top' }]" @click="tabPosition = 'top'">折线</div>
          <div :class="['item', 'item2', { 'item-active': tabPosition == 'left' }]" @click="tabPosition = 'left'">柱状</div>
        </div>
        <vchart ref='vchart3' style="height: 75%" v-show="tabPosition == 'top'"></vchart>
        <vchart ref='vchart2' style="height: 75%" v-show="tabPosition == 'left'"></vchart>

        <div class="divider-line"></div>

      </div>
    </div>

  </div>
</template>

<script>
import vchart from '@/components/module/chart/vchart.vue'
import elUnitTree2 from '@/components/module/newTree/elUnitTree2.vue';
import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
import request from "@/api/http.js";
import { parseTime } from "@/utils";
export default {
  components: {
    vchart,
    elUnitTree,
    elUnitTree2
  },

  data() {
    return {
      mined: 0,
      timeOut: '',//定时器
      variableNames: '',
      shouMenu: false,
      shouMenu2: false,
      all: [],//总no数据
      flag: false,
      nowPage: [],
      deviceNos: [],
      dataed: [],
      dataed_un: [],
      aaa: Math.floor(Math.random() * 10),
      defaultProps: '',
      heights: Math.round((document.getElementById('app').clientHeight) * 0.28),
      tabPosition: 'top',
      apptypeValue: [],
      nowIndex: 0,
      from2name: {},
      nowApptypeGroups: [],
      nowSeries: [],
      refreshInterval: 2000,
      columns: [{
        name: '设备名称',
        key: 'devicename'
      }, {
        name: '变量名称',
        key: 'variablename'
      }, {
        name: '实时值',
        key: 'value'
      }],
      options: {
        title: {
          text: "实时曲线(折线)",
          left: 'left',
          textStyle: {
            fontWeight: 500,
            fontSize: 16,
            color: "#1a1a1a"
          }
        },
        toolbox: {
          show: true,
          showTitle: true, // 隐藏默认文字，否则两者位置会重叠
          top: '-5',
          right: "30",
          feature: {
            magicType: {
              type: ['stack', 'tiled'], title: {
                stack: '切换为堆叠',
                tiled: '切换为平铺',
              }
            },

            saveAsImage: {
              show: true,
              title: '下载图片'
            },

          },

        },
        tooltip: {
          trigger: 'axis',
          confine: true,
          formatter: (params, ticket, callback) => {
            var label = new Date(params[0].data[0]).formatByTime() + "</br>"
            params.forEach(item => {
              var values;
              var danwei;
              if (isnull(item.data[1])) {
                values = "无采集数据";
                danwei = "";
              } else {
                values = cutDigital(item.data[1]);
                danwei = item.data[2];
              }
              label += item.seriesName + " : " + values + " " + danwei + "</br>"
            })

            return label;
          },
          axisPointer: {
            animation: false
          }
        },
        xAxis: {
          type: 'time',
          splitLine: {
            show: true
          }
        },
        yAxis: {
          type: 'value',
          max: value => {
            return Math.ceil(value.max) | 0 + 10
          },
          boundaryGap: [0, '100%'],
          splitLine: {
            show: true
          }
        },
        grid: {
          left: '5%',
          right: '30',
          bottom: '70'
        },
        legend: {
          type: 'scroll',
          bottom: '20px',
          right: 30,
          formatter: function (name) {
            return echarts.format.truncateText(name, 100, '14px Microsoft Yahei', '…');
          },
          tooltip: {
            show: true
          },
          selected: {}
        },
        series: []
      },
      total: 0,
      currentPage: 1,
      currentSize: 10,
      nowVirtualDeviceList: [],
      copyNowVirtualDeviceList: [],
      mynum: 1
    }
  },

  mounted() {
    this.apptypeValue = this.nowSelectAppTypeGroupIds;
    this.$refs.vchart3.setData(this.options, true)
    this.$refs.vchart2.setData(this.options, true)
    this.mysearch();
    this.timeOut = setInterval(() => {
      this.mysearch();
    }, 5000);


  },
  // 销毁
  destroyed() {
    clearInterval(this.timeOut)
  },
  computed: {
    // nowVirtualDeviceList () {
    //   return this.$store.deviceStore.state.nowVirtualDeviceList
    // },
    nowSelectAppTypeGroupIds() {
      return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(this.apptypeGroups)
    },
    getBackgroudImageStyle() {
      return this.$store.resourcesStore.getters.getBackgroudImageStyle
    },
    getResourcesByName() {
      return this.$store.resourcesStore.getters.getResourcesByName
    },
    variableStore() {
      return this.$store.variableStore
    },
    archivesStore() {
      return this.$store.archivesStore
    },
    deviceStore() {
      return this.$store.deviceStore
    },
    virtualDeviceList() {
      var data = this.$store.deviceStore.getters.getReadDeviceTree
      return isempty(data) ? [] : [deviceList(data)]
    },
    realTimeValueStore() {
      return this.$store.realTimeValueStore
    },

    variableTree() {
      if (isempty(this.nowVirtualDeviceList)) {
        return []
      }
      var variableTreeArr = []
      this.nowVirtualDeviceList.forEach(item => {
        var variableTree = []
        if (item.type == "virtualDevice") {
          if (variableTree.length == 0) {
            variableTree = this.variableStore.getters.getVariableTree(item.no)
          }
        }
        variableTree.forEach(tree => {
          tree.devicename = item.name
        })
        variableTreeArr.push(variableTree)
      })
      var result = []
      variableTreeArr.forEach(item => {
        result = result.concat(item)
      })
      return result
    },
    apptypeGroups() {
      //所有已选中的设备所具有的变量类型组
      var list = []
      var apptypeGroupIds = []
      this.variableTree.forEach(apptypeGroup => {
        if (!apptypeGroupIds.includes(apptypeGroup.id)) {
          apptypeGroupIds.push(apptypeGroup.id)
          list.push(apptypeGroup)
        }
      })

      //排序
      list.sort((a, b) => {
        return a.serialnum - b.serialnum
      })

      let idList = []
      list.forEach(item => {
        idList.push(item.id)
      })
      this.apptypeValue = idList
      return list
    },
    variableNameList() {
      //当前应该显示的变量fromname列表
      var ag = this.nowApptypeGroups.map(item => {
        return item.id
      })
      var v1 = this.variableTree.filter(item => {
        return ag.includes(item.id)
      })
      if (isempty(v1)) {
        return []
      }
      var v2 = []
      v1.forEach(item => {
        item.next.forEach(i => {
          this.from2name[i.fromName] = i.name + '(' + item.unit + ')'
          v2.push(i.fromName)
        })
      })
      return v2
    },
    nowVariableList() {
      //当前应该显示的变量fromname列表
      var ag = this.nowApptypeGroups.map(item => {
        return item.id
      })
      var v1 = this.variableTree.filter(item => {
        return ag.includes(item.id)
      })
      if (isempty(v1)) {
        return []
      }
      var v2 = []
      v1.forEach(item => {
        item.next.forEach(i => {
          i.devicename = item.devicename
          v2.push(i)
        })
      })
      v2.sort((a, b) => {
        return a.typeNo - b.typeNo
      })

      return v2
    },
    pageLen() {
      return this.dataList.length < this.currentSize ? this.dataList.length : this.currentSize
    },

    dataList() {
      //获取值
      var vl = this.realTimeValueStore.getters.getValue(this.variableNameList)
      return this.variableNameList.map((item, index) => {
        var value = this.realTimeValueStore.getters.getText(item, vl[index])
        if (isNaN(parseFloat((value))) || isnull(parseFloat((value)))) {
          value = '- -'
        }
        var name = this.from2name[item] ? this.from2name[item] : item
        let deviceName = ''
        this.nowVariableList.forEach(item2 => {
          if (item2.fromName == item) {
            deviceName = item2.fromName.split('.')[0]
          }
        })
        return {
          devicename: deviceName,
          variablename: name.subByFirstChar("."),
          value,
        }
      })

    }
  },
  watch: {

    variableNameList(nv, ov) {

    },
    apptypeValue(nv, ov) {
      this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', nv)
      let list = []
      if (!isempty(nv)) {
        nv.forEach(item => {
          this.apptypeGroups.forEach(item2 => {
            if (item == item2.id) {
              list.push(item2)
            }
          })
        })
      }
      this.nowApptypeGroups = list
    },
    copyNowVirtualDeviceList(val) {
      this.mynum += 1
      if (this.mynum == 2) {
        this.nowVirtualDeviceList = val
      }
    }
  },
  methods: {
    checkFun2(v) {
      if (v == 1) {
        this.updateEnableStatus(this.copyNowVirtualDeviceList);
        this.shouMenu2 = false;
      } else {
        this.defaultProps = v;
      }

    },
    checkFun(val) {
      var d = [];
      this.dataed = [];
      this.deviceNos = [];
      val.map(v => {
        this.deviceNos.push(v.no)
        d.push(v.no);
      })
      if (val.length) {
        this.copyNowVirtualDeviceList = d;
        this.updateEnableStatus(this.copyNowVirtualDeviceList)
      }
    },
    // 应用类型->修改应用类型参与查询状态
    updateEnableStatus(data) {
      var params = {
        deviceNos: data.join(',')
      }
      // /variable/findAppTypeByDeviceNo
      request({ url: "/variable/findAppTypeByDeviceNo", method: "get", params }).then(res => {

        if (res.code == 200) {
          this.dataed = res.data.used;
          this.all = []
          this.defaultProps = [];
          this.dataed.map(v => {
            if (v.children) {
              v.children.map(a => {
                this.all.push(a.no)
                if (a.enable === 0) {
                  this.defaultProps.push(a.no);
                }
              })
            }
          })
          this.dataed_un = res.data.unused;
        }
      })
    },
    mysearch2() {
      var params = {
        variableNames: '相对幅值.A相电流,相位.B相电流,周期.C相电流'
      }
      var res = {
        "code": 200,
        "message": "操作成功",
        "data": [
          {
            "deviceName": "相对幅值",
            "variableName": "A相电流",
            "currentValue": Math.floor(Math.random() * 10),
            "valueUnit": "A",
            "changeTime": "1665977760000",
            "status": 0
          },
          {
            "deviceName": "相位",
            "variableName": "B相电流",
            "currentValue": Math.floor(Math.random() * 10),
            "valueUnit": "A",
            "changeTime": "1665977760000",
            "status": 0
          },
          {
            "deviceName": "周期",
            "variableName": "C相电流",
            "currentValue": Math.floor(Math.random() * 10),
            "valueUnit": "A",
            "changeTime": "1665977760000",
            "status": 0
          }
        ]
      };
      var nowTime = new Date().getTime();
      this.nowPage = res.data;
      this.nowPage.map(v => {
        v.changeTime2 = parseTime(v.changeTime, "{y}-{m}-{d} {h}:{i}:{s}")
      });

      if (this.variableNames == params.variableNames) {  //相同请求参数  
        var columnar = this.options.series;

        var d = []//所有值
        columnar.forEach((item, index) => {
          item.data.shift()
          item.data.push([nowTime, this.nowPage[index].currentValue, this.nowPage[index].valueUnit])
          item.data.map(v => {
            if (v[1]) {
              d.push(v[1])
            }
          })
        })
        this.mined = Math.min(...d);
        if (this.options.yAxis.min != this.mined) {
          this.options.yAxis.min = this.mined;
          this.$refs.vchart3.setData(this.options)
        }

        this.$refs.vchart3.setData({
          series: columnar
        });

        var dataed = JSON.parse(JSON.stringify(columnar));

        if (dataed.length) {
          dataed.map(v => {
            v.type = 'bar'
          })
        }
        this.$refs.vchart2.setData({
          series: dataed
        })
      } else {
        var d = []
        var name = [];
        this.nowPage.map(v => {
          name.push({ "name": v.deviceName + '.' + v.variableName, "icon": "roundRect" })
          this.options.yAxis.min = v.currentValue; //设置最小值
          var dataList = [[nowTime, v.currentValue, v.valueUnit]]
          for (var i = 0; i < 20; i++) {
            dataList.unshift([nowTime - this.refreshInterval * i, undefined])
          }
          d.push({
            name: v.deviceName + '.' + v.variableName,
            fromName: v.variableName,
            type: 'line',
            markPoint: {
              data: [{
                name: '最大值',
                type: 'max'
              }]
            },
            smooth: false,
            symbol: 'emptyCircle',
            data: dataList
          })
        });
        this.options.series = d;
        this.options.legend.data = name;
        this.$refs.vchart3.setData(this.options, true)

        var columnar2 = JSON.parse(JSON.stringify(this.options))
        columnar2.series.map(v => {
          v.type = 'bar'
        })
        columnar2.yAxis.min = '0';
        columnar2.title.text = '实时曲线(柱状)';
        this.$refs.vchart2.setData(columnar2, true)
        this.variableNames = params.variableNames;//保存请求参数 

      }

    },

    mysearch() {
      var d = getMenuListAll();
      if (d[0].webpage == '/platform') {
        this.mysearch2()
        return
      }
      var params = {
        variableNames: '设备机电总进线数显表.A相电流,设备机电总进线数显表.B相电流,设备机电总进线数显表.C相电流,设备机电总进线数显表.A相有功功率,设备机电总进线数显表.B相有功功率,设备机电总进线数显表.C相有功功率,设备机电总进线数显表.总有功功率'
      }
      var res = {
        "code": 200,
        "message": "操作成功",
        "data": [
          {
            "deviceName": "设备机电总进线数显表",
            "variableName": "A相电流",
            "currentValue": Math.floor(Math.random() * 10),
            "valueUnit": "A",
            "changeTime": "1665977760000",
            "status": 0
          },
          {
            "deviceName": "设备机电总进线数显表",
            "variableName": "B相电流",
            "currentValue": Math.floor(Math.random() * 10),
            "valueUnit": "A",
            "changeTime": "1665977760000",
            "status": 0
          },
          {
            "deviceName": "设备机电总进线数显表",
            "variableName": "C相电流",
            "currentValue": Math.floor(Math.random() * 10),
            "valueUnit": "A",
            "changeTime": "1665977760000",
            "status": 0
          },
          {
            "deviceName": "设备机电总进线数显表",
            "variableName": "A相有功功率",
            "currentValue": Math.floor(Math.random() * 10) + 20,
            "valueUnit": "kW",
            "changeTime": "1665977760000",
            "status": 0
          },
          {
            "deviceName": "设备机电总进线数显表",
            "variableName": "B相有功功率",
            "currentValue": Math.floor(Math.random() * 10) + 10,
            "valueUnit": "kW",
            "changeTime": "1665977760000",
            "status": 0
          },
          {
            "deviceName": "设备机电总进线数显表",
            "variableName": "C相有功功率",
            "currentValue": Math.floor(Math.random() * 10) + 10,
            "valueUnit": "kW",
            "changeTime": "1665977760000",
            "status": 0
          },
          {
            "deviceName": "设备机电总进线数显表",
            "variableName": "总有功功率",
            "currentValue": Math.floor(Math.random() * 10),
            "valueUnit": "无",
            "changeTime": "1665977760000",
            "status": 0
          }
        ]
      };
      var nowTime = new Date().getTime();
      this.nowPage = res.data;
      this.nowPage.map(v => {
        v.changeTime2 = parseTime(v.changeTime, "{y}-{m}-{d} {h}:{i}:{s}")
      });

      if (this.variableNames == params.variableNames) {  //相同请求参数  
        var columnar = this.options.series;

        var d = []//所有值
        columnar.forEach((item, index) => {
          item.data.shift()
          item.data.push([nowTime, this.nowPage[index].currentValue, this.nowPage[index].valueUnit])
          item.data.map(v => {
            if (v[1]) {
              d.push(v[1])
            }
          })
        })
        this.mined = Math.min(...d);
        if (this.options.yAxis.min != this.mined) {
          this.options.yAxis.min = this.mined;
          this.$refs.vchart3.setData(this.options)
        }

        this.$refs.vchart3.setData({
          series: columnar
        });

        var dataed = JSON.parse(JSON.stringify(columnar));

        if (dataed.length) {
          dataed.map(v => {
            v.type = 'bar'
          })
        }
        this.$refs.vchart2.setData({
          series: dataed
        })
      } else {
        var d = []
        var name = [];
        this.nowPage.map(v => {
          name.push({ "name": v.deviceName + '.' + v.variableName, "icon": "roundRect" })
          this.options.yAxis.min = v.currentValue; //设置最小值
          var dataList = [[nowTime, v.currentValue, v.valueUnit]]
          for (var i = 0; i < 20; i++) {
            dataList.unshift([nowTime - this.refreshInterval * i, undefined])
          }
          d.push({
            name: v.deviceName + '.' + v.variableName,
            fromName: v.variableName,
            type: 'line',
            markPoint: {
              data: [{
                name: '最大值',
                type: 'max'
              }]
            },
            smooth: false,
            symbol: 'emptyCircle',
            data: dataList
          })
        });
        this.options.series = d;
        this.options.legend.data = name;
        this.$refs.vchart3.setData(this.options, true)

        var columnar2 = JSON.parse(JSON.stringify(this.options))
        columnar2.series.map(v => {
          v.type = 'bar'
        })
        columnar2.yAxis.min = '0';
        columnar2.title.text = '实时曲线(柱状)';
        this.$refs.vchart2.setData(columnar2, true)
        this.variableNames = params.variableNames;//保存请求参数 

      }

    },

    downloadExcel() {
      let title = '<thead><tr>'
      title += '<th colspan=6>' + new Date().formatByTime('-') + ' 实时值' + '</th>'
      title += '</tr></thead>'
      let aa = document.getElementsByTagName('thead')[0];//头部表达
      let bb = document.getElementsByTagName('tbody')[0];//列表内容
      let table = title + aa.innerHTML + bb.innerHTML
      exportToExcel(table, "实时值报告")
    },
    selectAll() {
      //全选 先判断是否有选中的，有选中就清空
      if (this.apptypeValue.length == 1) {
        this.nowApptypeGroup = this.apptypeGroups
        let idList = []
        this.apptypeGroups.forEach(item => {
          idList.push(item.id)
        })
        this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', idList)
        this.apptypeValue = idList
      } else {
        this.nowApptypeGroup = []
        this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', [])
        this.apptypeValue = []
      }

    },
    addData() {
      //获取值
      if (this.$refs.vchart == undefined) {
        return
      }
      var vl = this.realTimeValueStore.getters.getValue(this.variableNameList)
      var now = new Date().getTime()
      this.nowSeries.forEach((item, index) => {
        item.data.shift()
        var temp = vl[index]
        if (isNaN(parseFloat((temp))) || isnull(parseFloat((temp)))) {
          temp = undefined
        }
        item.data.push([now, temp])
      })
      // this.$refs.vchart.setData({
      //   series: this.nowSeries
      // })
      var columnar = JSON.parse(JSON.stringify(this.nowSeries))
      columnar.forEach(item => item.type = 'bar')
      this.$refs.vchart2.setData({
        series: columnar
      })

    },
    //分页功能 
    handleSizeChange(val) {
      this.currentSize = val;
      // this.getList()
    },
    handleCurrentChange(val) {
      this.nowIndex = val - 1;
      // this.getList()
    }
  }
}
</script>


<style scoped lang="scss">
.myvirtualDeviceRTCurve {
  .con {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;

    .myradio-group {
      display: flex;
      position: absolute;
      top: 12px;
      right: 20px;
      z-index: 10;

      .item {
        width: 52px;
        height: 34px;
        border: 1px solid #e6e6e6;
        color: #999999;
        text-align: center;
        line-height: 34px;
        cursor: pointer;

        &.item-active {
          border-color: #368ED9;
          color: #368ED9;
          background-color: #DEEFFE;
        }
      }

      .item1 {
        border-radius: 2px 0px 0px 2px;

      }

      .item2 {
        border-radius: 0px 2px 2px 0px;
      }
    }

    .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 15px;
    }

    .tree-left {
      width: 3rem;
      height: 100%;
      padding: 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;

      .btns {
        display: flex;
        // justify-content: space-evenly;
        margin-bottom: 8px;

        button {
          margin-right: 12px;
        }

        .el-button--mini {
          padding: 7px 10px !important;
        }

        .el-button+.el-button {
          margin-left: 0px;
        }
      }

      .search {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      }

    }

    .right-table {
      width: calc(100% - 3.08rem);
      height: 90vh;
      padding: 2px 20px 20px 20px;
      box-sizing: border-box;
      background-color: #fff;
      position: relative;

      .mycharts {
        display: flex;

        .charts-left {
          width: 35%;
        }

        .charts-right {
          width: 70%;
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
.unitMenu {
  max-width: 4rem;
  height: 4rem;
  top: 0;
  margin-left: 78px !important;
  padding-top: .5rem;
  position: absolute;
  z-index: 99999;
}

.unitMenu .elUnitTreeBody {
  width: 2.4rem;
}

.unitMenu .readDeviceTreeBody {
  border-width: 1px;
  border-style: solid;
  border-radius: 0 0 10px 10px;
}

.input_small2 {
  position: absolute;
  z-index: 9;
  top: 250px;
  left: 105px;
  align-items: flex-start;
}

.myvirtualDeviceRTValue {
  .con {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    // 正常
    .patrol {
      p {
        width: 8px;
        height: 8px;
        background-color: #0DAE88;
        border-radius: 50%;
        margin-right: 8px;
      }

      span {
        color: #0DAE88;
      }
    }

    // 非正常
    .rush {
      p {
        width: 8px;
        height: 8px;
        background-color: #FF1D1D;
        border-radius: 50%;
        margin-right: 8px;
      }

      span {
        color: #FF1D1D;
      }
    }

    .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 15px;
    }

    .tree-left {
      width: 3rem;
      height: 100%;
      padding: 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;

      .btns {
        display: flex;
        // justify-content: space-evenly;
        margin-bottom: 8px;

        button {
          margin-right: 12px;
        }

        .el-button--mini {
          padding: 7px 10px !important;
        }

        .el-button+.el-button {
          margin-left: 0px;
        }
      }

      .search {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      }

    }

    .right-table {
      width: calc(100% - 3.08rem);
      height: 90vh;
      padding: 2px 20px 20px 20px;
      box-sizing: border-box;
      background-color: #fff;
      position: relative;

      .mycharts {
        display: flex;

        .charts-left {
          width: 35%;
        }

        .charts-right {
          width: 70%;
        }
      }
    }
  }
}
</style>
<style scoped>
.block {
  width: 20px;
  height: 20px;
  background-color: #d9d9d9;
  cursor: pointer;
  margin-left: 10px;
}

.unitMenu {
  max-width: 4rem;
  height: 4rem;
  top: 7px;
  margin-left: 78px;
  padding-top: .5rem;
  position: absolute;
  z-index: 99999;
}

.unitMenu .elUnitTreeBody {
  width: 2.4rem;
}

.unitMenu .readDeviceTreeBody {
  border-width: 1px;
  border-style: solid;
  border-radius: 0 0 10px 10px;
}

.cropper-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ul {
  padding: 0 15px;
}

.ul .li {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
}

.ul .li .r {
  color: #378cd4;
  cursor: pointer;
}

.btns {
  width: 300px;
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #d7d7d7;
  margin: 0 15px;
}

.color-span {
  display: inline-block;
  width: 15px;
  height: 15px;
  transform: translate(5px, 2px);
  color: #1a1a1a;
}

.user-arrow {
  width: 20px;
  height: 20px;
}

.tongyi-img {
  width: 20px;
  height: 20px;
}

.arrow-active {
  transform: rotateZ(180deg);
}

.topMenu {
  height: .5rem;
  overflow-y: hidden;
  /* overflow: hidden; */
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.nowUnit-name {
  margin-left: 0.2rem;
  width: 2.14rem;
  height: 30px;
  border: 1px solid #ccc;
  text-align: left;
  line-height: 30px;
  padding: 0px 12px;
  /* margin-left: 5px; */
  border-radius: 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nowUnit-name span {
  color: #666666;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.nowUnit-name img {
  width: 18px;
  height: 18px;
  transition: 0.5s;
}

.nowUnit-active {
  border: 1px solid #409eff;
}

.nowUnit-active1 {
  border: 1px solid #fff;
}

.nowUnit-active img {
  transform: rotateZ(180deg);
}

.nowUnit-active1 img {
  transform: rotateZ(180deg);
}

/* 需要转化 */
.tags-view-container {
  height: 34px;
  width: calc(100% - 2rem);
  position: absolute;
  top: 48px;
  left: 200px;
  /* margin-left: 200px; */
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  -webkit-box-shadow: 0 1px 3px 0 rgb(0 0 0 / 12%), 0 0 3px 0 rgb(0 0 0 / 4%);
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 12%), 0 0 3px 0 rgb(0 0 0 / 4%);
  z-index: 999;

}

.tags-view-container .content {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
}

.sidebar-logo {
  width: 32px;
  height: 32px;
  vertical-align: middle;
}

.sidebar-title {
  display: inline-block;
  margin: 0;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
  vertical-align: middle;
  margin-left: 10px;
}

/* 需要转化结束 */


.userName {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #1a1a1a;
}

.webTitle {
  height: .5rem;
  width: auto;
  text-align: center;
  line-height: .5rem;
  font-size: 21px;
  font-weight: bold;
  width: 500px;
  color: #212529
}

.leftPart {
  /* width: calc(50% - 150px); */
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /* background-color: #2b2f3a; */
  /* background-color: #fff; */
}

.leftPart-logo {
  width: 2rem;
  height: 0.5rem;
  box-sizing: border-box;
  padding: 9px;
  /* background-color: #304156; */
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.35s;
  flex-shrink: 0;
}

.leftPart-logo-active {
  width: 0.8rem;
}

.logo {
  max-width: 185px;
  max-height: 40px;
}

.rightPart {
  /* width: calc(50% - 50px); */
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.leftPartImg {
  height: 48px;
  display: flex;
  align-items: center;
  width: 50px;
  /*border-bottom: 2px solid #116af0;*/
}

.rightPart .user {
  /* width: auto; */
  margin-left: 10px;
  max-width: 2rem;
  min-width: .2rem;
  /* height: .2rem; */
}

.rightPart .userSelect {
  cursor: pointer;
  width: auto;
  max-width: 2rem;
  min-width: .08rem;
  height: .06rem;
  margin-right: 20px;
  margin-top: 11px;
}

.unitSelect {
  min-width: 1rem;
  height: 100%;
  /*border-bottom: 2px solid #cce1ff;*/
  height: 48px;
}

.unitSelect>div>input {
  width: 150px;
  background: rgba(0, 0, 0, 0);
  border: 0;
  /* border-left: 1px #49649c solid; */
  border: 1px solid #dcdfe6;
  border-radius: 0;
  padding: 5px 10px;
  height: 20px;
  line-height: 20px;
  outline: none;
  margin: 0 10px;
  color: white;
}

.userMenu {
  padding-top: .5rem;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 9999;
}



.area-tree {
  position: absolute;
  max-width: 2.5rem;
  height: 4rem;
  /* margin-left: 4rem; */
  /* top: 0; */
  top: 0;
  /* right: 0px; */
  margin-left: 19px;
  padding-top: .5rem;
  z-index: 99999;
  width: 77%;
}

.area-tree .elUnitTreeBody {
  width: 2.4rem;
}

.area-tree .readDeviceTreeBody {
  border-width: 1px;
  border-style: solid;
  border-radius: 0 0 10px 10px;
}

.menuItem {
  height: 33px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .05rem .1rem;
  width: auto;
  cursor: pointer;
  background: white;
  border-left: solid .01rem #BABEC2;
  border-right: solid .01rem #BABEC2;
  border-bottom: solid .01rem #BABEC2;
}

.menuItem:last-child {
  border-radius: 0 0 .05rem .05rem;
}

.menuItem>span {
  text-align: left;
  width: .7rem;
  padding-left: .1rem;
}

.tool-class {
  width: 50%;
}

.nowTimeBox {
  /*border-bottom: 2px solid #cce1ff;*/
  height: 48px;
  /* color: white; */
  color: #666666;
  line-height: 50px;
  margin-right: 10px;
}

.msgDialog {
  position: absolute;
  width: 360px;
  height: 440px;
  background: white;
  z-index: 5;
  top: 50px;
  right: 20px;
  border-radius: 5px;
  border: 1px silver solid;
  z-index: 110;
}

.msgDialog>p {
  padding-right: 20px;
  line-height: 40px;
  text-align: right;
  border-bottom: 1px silver solid;
  color: #0092DC;
}

/* 修改默认列表样式 */

.msgDialog>>>ul.list-body {
  border-radius: 0;
}

.msgDialog>>>ul.list-body>li {
  padding: 0;
  border-bottom: none;
  background: none;
  cursor: default;
}

.msgOperate {
  overflow: hidden;
  padding: 0 24px;
  border-bottom: solid 1px #CCCCCC;
}

.msgOperate>button {
  height: 20px;
  box-sizing: border-box;
  margin: 8px 12px;
  color: #0F87DB;
  padding: 0 8px;
  background: #FFFFFF;
  outline: none;
  border: solid 1px #FFFFFF;
  border-radius: 10px;
  cursor: pointer;
}

.msgOperate>.isFilter {
  border-color: #0F87DB;

}

.isFilter {
  color: #0F87DB;
  background: none;
}

.msgOperate>span {
  float: right;
  line-height: 36px;
}

.filterDialog {
  position: absolute;
  height: 300px;
  width: 250px;
  background: white;
  top: 50px;
  z-index: 100;
}

.unitName {
  max-width: 140px;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.existMsg {
  position: absolute;
  left: 5px;
  top: -5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: red;
  color: #FFFFFF;
  font-size: .12rem;
  text-align: center;
  line-height: 20px;
  transform: scale(0.6);
}

.unreadMsgInfo {
  padding: 10px 24px 0 24px;
}

.unreadHead {
  margin-bottom: 6px;
  overflow: hidden;
}

.msgTypeName {
  float: left;
  background: #0582DA;
  line-height: 18px;
  padding: 0 8px;
  border-radius: 8px;
  font-size: .12rem;
  color: #FFFFFF;
}

.msgMarkBtn {
  float: right;
  height: 18px;
  box-sizing: border-box;
  border: solid 1px #0F87DB;
  border-radius: 8px;
  font-size: .12rem;
  padding: 0 8px;
  line-height: 16px;
  color: #0F87DB;
  background: #FFFFFF;
  cursor: pointer;
}

.msgTimeText {
  float: right;
  line-height: 18px;
  font-size: .12rem;
  color: #0F87DB;
}

.msgIntro {
  font-size: .12rem;
  text-indent: 2em;
  padding-bottom: 10px;
  border-bottom: solid 1px #CCCCCC;
  white-space: normal;
}

.unReadMsg {
  background-color: #E3EBF1;
}
</style>